/**
 * Email Signup Block Component
 *
 * Handles dynamic padding adjustment for email signup input fields
 * when integrated buttons have variable widths. Also tracks email address
 * form submissions.
 */
class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    /** @type {number} */
    this.lastButtonWidth = 0;
    /** @type {ResizeObserver | undefined} */
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    
    this.input = this.querySelector('input.email-signup__input, .email-signup__input input, input[type="email"]');
    this.inputGroup = this.querySelector('.email-signup__input-group');
    
    this.form = this.closest('form') || this.querySelector('form');

    const isTextButton = this.button?.classList.contains('email-signup__button--text');

    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();
      this.observer = new ResizeObserver(() => this.adjustInputPadding());
      this.observer.observe(this.button);

      if ('fonts' in document) {
        document.fonts.ready.then(() => this.adjustInputPadding());
      }
    }

    if (this.form && this.input) {
      this.form.addEventListener('submit', this.handleSubmit);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
  }

  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    const buttonWidth = /** @type {HTMLElement} */ (this.button).offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      /** @type {HTMLElement} */ (this.inputGroup).style.setProperty('--button-actual-width', `${buttonWidth}px`);
    }
  }

  /**
   * Handles form submission and pushes event to GTM dataLayer
   * @param {Event} event 
   */
  handleSubmit(event) {
    event.preventDefault(); 

    const emailValue = /** @type {HTMLInputElement} */ (this.input)?.value?.trim().toLowerCase();

    if (emailValue) {
      window['dataLayer'] = window['dataLayer'] || [];
      window['dataLayer'].push({
        event: 'email_signup',
        form_type: 'newsletter',
        newsletter_email_address: emailValue
      });
    }

    setTimeout(() => this.form?.submit(), 500);
  }
}

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}